<template>
<div>
  <div class="custom-sidebar">
    <side-bar>
        <template slot="links">
          <sidebar-item :link="{name: 'Home',
                                icon: 'home',
                                path: '/'}" @click="linkClick">
          </sidebar-item>
          <sidebar-item :link="{name: 'Regiones',
                                icon: 'regiones',
                                path: '/regiones'}" @click="linkClick">
          </sidebar-item>
          <sidebar-item :link="{name: 'Cultivos',
                                icon: 'cultivo',
                                path: '/cultivos'}" @click="linkClick">
          </sidebar-item>
          <sidebar-item :link="{name: 'Comparativa',
                                icon: 'comparativa',
                                path: '/comparativa'}" @click="linkClick">
          </sidebar-item>
          <sidebar-item :link="{name: 'Precios',
                                icon: 'precios',
                                path: '/precios'}" @click="linkClick">

          </sidebar-item>
          <sidebar-item :link="{name: 'Ganadería',
                                icon: 'cow',
                                path: '/ganaderia'}" @click="linkClick">

          </sidebar-item>
          <sidebar-item :link="{name: 'Preguntas Frecuentes',
                                icon: 'preguntasfrecuentes',
                                path: 'preguntas-frecuentes'}" @click="linkClick">

          </sidebar-item>          
        </template>
    </side-bar>
  </div>
  <div
    class="top-social-navbar"
    v-show="showSocialBar"
  >
    <div class="top-social-inner">
      <!-- Links de redes sociales -->
      <a href="https://www.linkedin.com/company/55043511/" target="_blank" class="icon-redes-nav"><svg-icon type="mdi" :path="icons.linkedin"></svg-icon></a>  
      <a href="https://www.instagram.com/agbiagro/" target="_blank" class="icon-redes-nav"><svg-icon type="mdi" :path="icons.instagram"></svg-icon></a>  
      <a href="https://www.facebook.com/AgBIagro" target="_blank" class="icon-redes-nav"><svg-icon type="mdi" :path="icons.facebook"></svg-icon></a>  
      <a href="https://x.com/AgBI_agro" target="_blank" class="icon-redes-nav">X</a> 
    </div>
  </div>
  <div
    class="full-page md-custom-navbar"
    :class="{'nav-open': $sidebar.showSidebar}"
    :style="{ top: showSocialBar ? '32px' : '0' }"
  >
    <md-toolbar
      md-elevation="0"
      class="md-transparent"
      :class="{'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute}">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start header-logo">
          <router-link to="/"><h3>Ag<strong>BI</strong></h3></router-link>
        </div>
        <div class="md-toolbar-section-end">
          <div class="md-group pull-left">
            <drop-down direction="down">
              <md-button slot="title" class="md-button md-success md-sm dropdown-toggle" data-toggle="dropdown">
                {{campaignSelected}}
              </md-button>
              <ul class="dropdown-menu dropdown-menu-left">
                <li><a class="pointer" @click="changeCampaign(1)">{{campaignList[0]}}</a></li>
                <li><a class="pointer" @click="changeCampaign(2)">{{campaignList[1]}}</a></li>
                <li><a class="pointer" @click="changeCampaign(3)">{{campaignList[2]}}</a></li>
<!--                <li><a class="pointer" @click="changeCampaign(4)">{{campaignList[3]}}</a></li>-->
<!--                <li><a class="pointer" @click="changeCampaign(5)">{{campaignList[4]}}</a></li>-->
              </ul>
            </drop-down>
          </div>
          <md-button class="md-just-icon md-round md-simple md-toolbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>
          <div class="md-collapse">
            <md-list>
              <md-list-item to="/" @click="linkClick">
                    <svg-icon v-if="icons.home" type="mdi" :path="icons.home" class="crop-icon" />
                    Home
                </md-list-item>
                <md-list-item to="/regiones" @click="linkClick">
                    <svg-icon v-if="icons.regiones" type="mdi" :path="icons.regiones" class="crop-icon" />
                    Regiones
                </md-list-item>
                <md-list-item to="/cultivos" @click="linkClick">
                    <CustomIcon name="cultivo"  class="crop-icon custom-icon" />
                    Cultivos
                </md-list-item>
                <md-list-item to="/comparativa" @click="linkClick">
                    <svg-icon v-if="icons.comparativa" type="mdi" :path="icons.comparativa" class="crop-icon" />
                    Comparativa
                </md-list-item>
                <md-list-item to="/precios" @click="linkClick">
                    <svg-icon v-if="icons.precios" type="mdi" :path="icons.precios" class="crop-icon" />
                    Precios
                </md-list-item>
                <md-list-item to="/ganaderia" @click="linkClick">
                    <CustomIcon name="cow"  class="crop-icon custom-icon" />
                    Ganadería
                </md-list-item>
                <md-list-item to="/preguntas-frecuentes" @click="linkClick">
                    <svg-icon v-if="icons.preguntasfrecuentes" type="mdi" :path="icons.preguntasfrecuentes" class="crop-icon" />
                    Preguntas Frecuentes
                </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </md-toolbar>
  </div>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiWeb, mdiCurrencyUsd, mdiSpa, mdiChartBoxMultipleOutline, mdiCow, mdiHelp, mdiHome, mdiFacebook, mdiLinkedin, mdiInstagram } from '@mdi/js'

export default {
  components: {SvgIcon},
  data() {
    return {
      icons: {
        home: mdiHome,
        regiones: mdiWeb,
        comparativa: mdiChartBoxMultipleOutline,
        cultivos: mdiSpa,
        precios: mdiCurrencyUsd,
        ganaderia: mdiCow,
        preguntasfrecuentes: mdiHelp,
        facebook: mdiFacebook,
        linkedin: mdiLinkedin,
        instagram: mdiInstagram,
      },
      showSocialBar: true
    }
  },
  computed: {
    ...mapState(['campaignList', 'campaignSelected'])
  },
  methods: {
    ...mapActions(['changeCampaign']),
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    linkClick() {
      if (this.$sidebar && this.$sidebar.showSidebar === true) {
        this.$sidebar.displaySidebar(false)
      }
    },

    closeMenu() {
      document.body.classList.remove('nav-open')
      this.showMenu = false
    },

    handleScroll() {
      // Muestra la barra de redes solo cuando el scroll está arriba
      this.showSocialBar = window.scrollY <= 0;
    },
  },
  mounted() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style>
.md-custom-navbar{
  background-color: #0061ad !important;
  border-radius: 0;
  position: fixed;
  z-index:999;
  right: 0;
  left:0;
  top:0;
}

.top-social-navbar{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 32px;
  background-color: #004c8a;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 40px;
}
.top-social-inner{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.top-social-inner a{
  color: #ffffff;
  margin-left: 10px;
  font-size: 16px;
}

.top-social-inner a:hover{
  color: #e0e0e0;
}

.md-custom-navbar i{
  color:white !important;
}
.pointer{
  cursor: pointer;
}
.header-logo h3{
  font-size:32px;
  color: white;
  margin: 0;
}

.main-panel > .content{
  padding: 15px;
  padding-top: 0;
  margin-top:68px;
}
.md-layout.layout-margin{
  padding-top:40px;
}
.icon-redes-nav {
  color: #fff !important;
  margin-left: 1rem;
  margin-right: 1rem;
  font-size: 1.2rem;
  text-align: center;
}
.icon-redes-nav:hover {
  color: #ddd !important;
}
.icon-redes-nav svg{
  height: 1rem;
}

@media (min-width: 992px) {
  .custom-sidebar {
    display:none;
  }
}

@media (max-width: 600px) {
  .md-layout.layout-margin{
    padding-top:80px;
  }
  #crops-section .md-layout.layout-margin{
    padding-top:40px;
  }
}

</style>
